// ─── FOMC scheduled meetings, 2026–2027 (sprint 13, stage 4) ────────────────
//
// A fixed list, not a live endpoint (David, 28/09/2026). FRED's "FOMC Press
// Release" is marked on every day, so it states no meeting date; the dates
// come from the Federal Reserve's own calendar page, copied once and checked
// against it on the date below.
//
// Each date is the meeting's last day, when the statement is released; `start`
// is its first. `sep` marks a meeting the Fed lists "associated with a
// Summary of Economic Projections".
//
// It stops on its own: after the last date in the list nothing is shown, and
// the next year is added by the annual update in academy/plan.md. The Fed
// notes that each date is tentative until confirmed at the meeting before it.
export const FOMC_SOURCE = {
  name: "Federal Reserve · Meeting calendars and information",
  url: "https://www.federalreserve.gov/monetarypolicy/fomccalendars.htm",
  checked: "2026-09-28",
  pageUpdated: "2026-09-16",
};

export const FOMC_MEETINGS = [
  { start: "2026-01-27", date: "2026-01-28" },
  { start: "2026-03-17", date: "2026-03-18", sep: true },
  { start: "2026-04-28", date: "2026-04-29" },
  { start: "2026-06-16", date: "2026-06-17", sep: true },
  { start: "2026-07-28", date: "2026-07-29" },
  { start: "2026-09-15", date: "2026-09-16", sep: true },
  { start: "2026-10-27", date: "2026-10-28" },
  { start: "2026-12-08", date: "2026-12-09", sep: true },
  { start: "2027-01-26", date: "2027-01-27" },
  { start: "2027-03-16", date: "2027-03-17", sep: true },
  { start: "2027-04-27", date: "2027-04-28" },
  { start: "2027-06-08", date: "2027-06-09", sep: true },
  { start: "2027-07-27", date: "2027-07-28" },
  { start: "2027-09-14", date: "2027-09-15", sep: true },
  { start: "2027-10-26", date: "2027-10-27" },
  { start: "2027-12-07", date: "2027-12-08", sep: true },
];
